<mat-form-field class="timer-wrapper">
  <mat-label>{{displayText}}</mat-label>

  <button
    mat-icon-button
    (click)="stopTimer(true)"
    *ngIf="isTimerRunning"
    aria-label="Stop Timer"
    title="Stop Timer"
  >
    <mat-icon>stop</mat-icon>
  </button>
  <button
    mat-icon-button
    (click)="startTimer()"
    *ngIf="!isTimerRunning"
    aria-label="Start Timer"
    title="Start Timer"
  >
    <mat-icon>play_arrow</mat-icon>
  </button>
</mat-form-field>
